import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useFieldContext } from '@/domain/mitarbeiter/shared/components/form/hooks';
import { FieldProps } from '@/domain/mitarbeiter/shared/components/form/types';
import { Input, InputProps } from '@e2n/ui/v2';
import { faEuro } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

const numberMaskingOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: '.',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  decimalSeparator: ',',
  min: 0,
});

export function MoneyInput({
  label,
  description,
  isRequired,
  placeholder,
  className,
  infoText,
  ...inputProps
}: FieldProps & InputProps) {
  const field = useFieldContext<string>();
  const ref = useMaskito({ options: numberMaskingOptions });
  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      infoText={infoText}>
      <Input
        id={field.name}
        name={field.name}
        placeholder={placeholder}
        ref={ref}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        value={field.state.value ?? ''}
        inputMode="numeric"
        showSuffix
        suffix={<FontAwesomeIcon icon={faEuro} className="size-3.5" />}
        className={className}
        {...inputProps}
      />
    </FieldBase>
  );
}
